<template>
  <div class="dd" ref="nestedList">
    <NestedDataList :listTree="nestedDataList" :editingOrder="editingOrder" :collapsable="collapsable">
      <template v-for="slot in Object.keys($scopedSlots)" v-slot:[slot]="scope">
        <slot :name="slot" v-bind="scope"/>
      </template>
    </NestedDataList>
  </div>
</template>

<style>
.dd-empty {
  display: none;
}
</style>

<script>
import _ from 'lodash'
import NestedDataList from '@/components/table/nestedDataList.vue'

export default {
  name: "NestedList",
  components: {
    NestedDataList
  },
  props: {
    listTree: Array,
    editingOrder: Boolean,
    collapsable: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      nestedDataList: []
    }
  },
  watch: {
    listTree: function(newVal, oldVal) {
      this.$data.nestedDataList = _.clone(newVal)
    }
  },
  mounted() {
    $(this.$refs.nestedList).nestable({ maxDepth: 10 })

    $(this.$refs.nestedList).on('change', () => {
      this.$emit('change', this.generateNestedDataFromSerialized($(this.$refs.nestedList).nestable('serialize')))
    })
  },
  beforeDestroy() {
    // TODO: Might need to add dispose() to nestable to remove mouse events from document
    // TODO: Use nestable2 instead. Has destroy

    $(this.$refs.nestedList).off('change')
  },
  methods: {
    generateNestedDataFromSerialized(serializeData) {
      return serializeData.map(item => {
        var dataItem = _.clone(this.findNestedDataItem(this.$data.nestedDataList, item.id))
        if(dataItem) {
          dataItem.children = []
          if(item.children)
            dataItem.children = this.generateNestedDataFromSerialized(item.children)
        }

        return dataItem
      }).filter(item => item != null)
    },

    findNestedDataItem(nestedList, id) {
      for(var nestedItem of nestedList) {
        if(nestedItem.id == id)
          return nestedItem

        var foundItem = this.findNestedDataItem(nestedItem.children, id)
        if(foundItem)
          return foundItem
      }

      return null
    }
  }
};
</script>